
export function ProgressBar01 () {
    
      return (
        <>
            <div className="flex justify-between mb-1">
                <span className="text-base font-medium text-blue-700 dark:text-white">Progress</span>
                <span className="text-sm font-medium text-blue-700 dark:text-white">1%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: '1%' }}></div>
            </div>
        </>
      )
  }

  export function ProgressBar02 () {
    
    return (
      <>
          <div className="flex justify-between mb-1">
                <span className="text-base font-medium text-blue-700 dark:text-white">Progress</span>
                <span className="text-sm font-medium text-blue-700 dark:text-white">18%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: '18%' }}></div>
            </div>
      </>
    )
}

export function ProgressBar03 () {
    
    return (
      <>
          <div className="flex justify-between mb-1">
                <span className="text-base font-medium text-blue-700 dark:text-white">Progress</span>
                <span className="text-sm font-medium text-blue-700 dark:text-white">36%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: '36%' }}></div>
            </div>
      </>
    )
}

export function ProgressBar04 () {
    
    return (
      <>
          <div className="flex justify-between mb-1">
                <span className="text-base font-medium text-blue-700 dark:text-white">Progress</span>
                <span className="text-sm font-medium text-blue-700 dark:text-white">52%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: '52%' }}></div>
            </div>
      </>
    )
}

export function ProgressBar05 () {
    
    return (
      <>
          <div className="flex justify-between mb-1">
                <span className="text-base font-medium text-blue-700 dark:text-white">Progress</span>
                <span className="text-sm font-medium text-blue-700 dark:text-white">72%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: '72%' }}></div>
            </div>
      </>
    )
}

export function ProgressBar06 () {
    
    return (
      <>
          <div className="flex justify-between mb-1">
                <span className="text-base font-medium text-blue-700 dark:text-white">Progress</span>
                <span className="text-sm font-medium text-blue-700 dark:text-white">90%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: '90%' }}></div>
            </div>
      </>
    )
}

export function ProgressBar07 () {
    
    return (
      <>
          <div className="flex justify-between mb-1">
                <span className="text-base font-medium text-blue-700 dark:text-white">Progress</span>
                <span className="text-sm font-medium text-blue-700 dark:text-white">100%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: '100%' }}></div>
            </div>
      </>
    )
}